<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<section class="xrx-circular-progress-bar">
  <svg class="progress-ring" width="120" height="120">
    <circle
      class="progress-ring__circle"
      #circle
      stroke="#3de300"
      stroke-width="7"
      fill="transparent"
      r="44"
      cx="60"
      cy="60" />
  </svg>
  @if (!complete) {
    <div class="perentage">
      <span>{{ roundPercentage }}%</span>
    </div>
  }
  <div class="checkmark">
    <span class="glyph xgl-checkmark"></span>
  </div>
</section>
